// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #1f415b; 
    color: rgb(255, 255, 255); 
    text-align: center;
    padding: 15px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 40px; 
    left: 0;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 999;
  }
  `, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IAIf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,OAAO;IACP,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;EACd","sourcesContent":[".footer {\n    background-color: #1f415b; \n    color: rgb(255, 255, 255); \n    text-align: center;\n    padding: 15px;\n    font-size: 14px;\n    width: 100%;\n    \n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 40px; \n    left: 0;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    z-index: 999;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
